// Barème 2025 - Automobiles thermiques/hydrogène/hybrides
const autoThermal = {
    "3cv": { low: 0.529, mid: { rate: 0.316, add: 1065 }, high: 0.370 },
    "4cv": { low: 0.606, mid: { rate: 0.340, add: 1330 }, high: 0.407 },
    "5cv": { low: 0.636, mid: { rate: 0.357, add: 1395 }, high: 0.427 },
    "6cv": { low: 0.665, mid: { rate: 0.374, add: 1457 }, high: 0.447 },
    "7cv": { low: 0.697, mid: { rate: 0.394, add: 1515 }, high: 0.470 },
};

// Barème 2025 - Automobiles électriques (majoration 20%)
const autoElectric = {
    "3cv": { low: 0.635, mid: { rate: 0.379, add: 1278 }, high: 0.444 },
    "4cv": { low: 0.727, mid: { rate: 0.408, add: 1596 }, high: 0.488 },
    "5cv": { low: 0.763, mid: { rate: 0.428, add: 1674 }, high: 0.512 },
    "6cv": { low: 0.798, mid: { rate: 0.449, add: 1748 }, high: 0.536 },
    "7cv": { low: 0.836, mid: { rate: 0.473, add: 1818 }, high: 0.564 },
};

// Barème 2025 - Motocyclettes thermiques (> 50 cm³)
const motoThermal = {
    "1-2cv": { low: 0.395, mid: { rate: 0.099, add: 891 }, high: 0.248 },
    "3-5cv": { low: 0.468, mid: { rate: 0.082, add: 1158 }, high: 0.275 },
    "5cv+": { low: 0.606, mid: { rate: 0.079, add: 1583 }, high: 0.343 },
};

// Barème 2025 - Motocyclettes électriques
const motoElectric = {
    "1-2cv": { low: 0.474, mid: { rate: 0.119, add: 1069 }, high: 0.298 },
    "3-5cv": { low: 0.562, mid: { rate: 0.098, add: 1390 }, high: 0.330 },
    "5cv+": { low: 0.727, mid: { rate: 0.095, add: 1900 }, high: 0.412 },
};

// Barème 2025 - Cyclomoteurs thermiques (≤ 50 cm³)
const cycloThermal = {
    cyclo: { low: 0.315, mid: { rate: 0.079, add: 711 }, high: 0.198 },
};

// Barème 2025 - Cyclomoteurs électriques
const cycloElectric = {
    cyclo: { low: 0.378, mid: { rate: 0.095, add: 853 }, high: 0.238 },
};

function getBareme(vehicleType, vehicleCategory) {
    if (vehicleCategory === "auto") {
        return vehicleType === "electric" ? autoElectric : autoThermal;
    }
    if (vehicleCategory === "moto") {
        return vehicleType === "electric" ? motoElectric : motoThermal;
    }
    if (vehicleCategory === "cyclo") {
        return vehicleType === "electric" ? cycloElectric : cycloThermal;
    }
    return null;
}

function getThresholds(vehicleCategory) {
    if (vehicleCategory === "auto") {
        return { lowMax: 5000, midMax: 20000 };
    }
    // Moto and cyclo use different thresholds
    return { lowMax: 3000, midMax: 6000 };
}

export function calculateIndemnity(vehicleType, vehicleCategory, power, kilometers) {
    const bareme = getBareme(vehicleType, vehicleCategory);
    if (!bareme || !bareme[power]) return 0;

    const rates = bareme[power];
    const { lowMax, midMax } = getThresholds(vehicleCategory);
    const d = kilometers;

    if (d <= lowMax) {
        return d * rates.low;
    } else if (d <= midMax) {
        return (d * rates.mid.rate) + rates.mid.add;
    } else {
        return d * rates.high;
    }
}